import React, { memo } from 'react';
import { Button, Col, Row } from 'reactstrap';
import DynamicAutoComplete from '../../EpikBoxes/DynamicAutoComplete';

const AddComponent = memo(
  ({
    onClick,
    name,
    onChange,
    searchTerm,
    dropdownList,
    isDisabled,
    placeholder,
    value,
    loading,
    onKeyDown,
  }) => {
    return (
      <Row>
        {!loading && (
          <>
            <Col sm={6}>
              <DynamicAutoComplete
                isDisabled={isDisabled}
                dropdownList={dropdownList}
                dropdownValue={searchTerm}
                onChange={onChange}
                searchTerm={value?.email}
                placeholder={placeholder}
                onKeyDown={onKeyDown}
              />
            </Col>
            <Col sm={6}>
              <Button color="primary" className="w-50" onClick={() => value?.email && onClick()}>
                {`Add ${name}`}
              </Button>
            </Col>
          </>
        )}
      </Row>
    );
  },
);

export default AddComponent;
